import { render } from "./Pen.vue?vue&type=template&id=2d83794e"
import script from "./Pen.vue?vue&type=script&lang=js"
export * from "./Pen.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__